class CompareProduct {
  constructor() {
    this.storageKey = 'm-compare-products'
    this.products = []
    this.productNodes = {}

    this.pageTemplate = 'page.product-compare'
    this.addedClass = 'added-to-compare'
    this.selectors = {
      container: '.m-compare-page-content__wrapper',
      noProducts: '.m-compare-no-products',
      wrapper: '.m-compare-card',
      item: '.m-product-card',
      compareButton: '.m-compare-button',
      compareText: '.m-compare-button-text',
      removeButton: '.m-compare-remove-button',
      count: '.m-compare-count'
    }
    this.products = Array.from(new Set(Array.from(JSON.parse(localStorage.getItem(this.storageKey)) || [])));
    this.isComparePage = MinimogSettings.template === this.pageTemplate;
    this.init()
  }

  init = () => {
    if (this.isComparePage) {
      this.renderComparePage();
      this.addEventToRemoveButtons();
    }
    this.setCompareButtonsState();
    this.addEventToCompareButtons();
    this.updateCompareCount();
  }

  saveToStorage = () => {
    this.products = Array.from(new Set(this.products))
    localStorage.setItem(this.storageKey, JSON.stringify(this.products))
  }

  addToCompare(handle) {
    if (handle && this.products.indexOf(handle) === -1) {
      this.products.push(handle)
      this.saveToStorage()
    }
  }

  removeFromCompare(handle) {
    this.products = this.products.filter(hdl => hdl !== handle)
    this.saveToStorage()
  }

setCompareButtonsState = () => {
  const buttons = document.querySelectorAll(this.selectors.compareButton)
  buttons.forEach(btn => {
    const prodHandle = btn && btn.dataset.productHandle
    if (this.products.indexOf(prodHandle) >= 0 && btn && !btn.classList.contains(this.addedClass)) {
      // toggleButtonState(btn, true) hata do — seedha class aur text set karo
      btn.classList.add(this.addedClass)
      const compareText = btn.querySelector(this.selectors.compareText)
      if (compareText) {
        const temp = compareText.dataset.revertText
        compareText.dataset.revertText = compareText.textContent
        compareText.textContent = temp
      }
    }
  })
}

  updateCompareCount = () => {
    const size = this.products.length
    const countElems = document.querySelectorAll(this.selectors.count);
    [...countElems].forEach(elem => {
      elem.textContent = size
      if (size < 1) {
        elem.classList.add('m:hidden')
      } else {
        elem.classList.remove('m:hidden')
      }
    })    
  }

 addEventToCompareButtons = () => {
  addEventDelegate({
    selector: this.selectors.compareButton,
    handler: (e, btn) => {
      e.preventDefault()
      const productHandle = btn && btn.dataset.productHandle
      if (productHandle) {
        const active = !btn.classList.contains(this.addedClass)
        this.toggleButtonState(btn, active)
        
        if (active) this.flyToCompare(btn)  // ← sirf yahan, click wale btn pe
        
        this.updateCompareCount();
        document.querySelectorAll(this.selectors.compareButton).forEach(btnItem => {
          if (btnItem && btnItem.dataset.productHandle === productHandle && btnItem !== btn) {
            const isAdded = !btnItem.classList.contains(this.addedClass)
            this.toggleButtonState(btnItem, isAdded)
            // flyToCompare yahan nahi — duplicate buttons pe animation nahi chahiye
          }
        })
      }
    }
  })
}

  toggleButtonState = (btn, active) => {
    const productHandle = btn && btn.dataset.productHandle
    const compareText = btn && btn.querySelector(this.selectors.compareText)

    if (active) {
      this.addToCompare(productHandle)
     
      btn.classList.add(this.addedClass)
    } else {
      this.removeFromCompare(productHandle)
      btn.classList.remove(this.addedClass)
    }

    if (compareText) {
      const temp = compareText.dataset.revertText
      compareText.dataset.revertText = compareText.textContent
      compareText.textContent = temp
    }
  }

  addEventToRemoveButtons = () => {
    addEventDelegate({
      selector: this.selectors.removeButton,
      handler: (e, btn) => {
        e.preventDefault()
        const prod = btn && btn.closest(this.selectors.wrapper)
        prod && prod.remove()

        const productHandle = btn && btn.dataset.productHandle
        if (productHandle) {
          this.removeFromCompare(productHandle)
          this.updateCompareCount()
          if (!this.products.length) {
            this.showNoProductsMessage()
          }
        }
      }
    })
  }
  // Apni existing class mein yeh method add karo:
flyToCompare = (btn) => {
  const card = btn.closest(this.selectors.item) || btn.closest('.m-product-card')
  const productImg = card && card.querySelector('img')

  const target = window.innerWidth < 768
    ? document.querySelector('.m-header__mobile-right .m-header__compare')
    : document.querySelector('.m-header__right .m-header__compare')

  if (!productImg || !target) return

  const imgRect = productImg.getBoundingClientRect()
  const targetRect = target.getBoundingClientRect()

  const fly = document.createElement('img')
  fly.src = productImg.src
  fly.style.cssText = `
    position: fixed;
    left: ${imgRect.left}px;
    top: ${imgRect.top}px;
    width: ${imgRect.width}px;
    height: ${imgRect.height}px;
    object-fit: cover;
    border-radius: 8px;
    pointer-events: none;
    z-index: 9999;
    opacity: 1;
    transition: left 0.65s cubic-bezier(0.25, 0.46, 0.45, 0.94),
                top 0.65s cubic-bezier(0.25, 0.46, 0.45, 0.94),
                width 0.65s ease,
                height 0.65s ease,
                opacity 0.65s ease;
  `
  document.body.appendChild(fly)

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      fly.style.left = (targetRect.left + targetRect.width / 2 - 30) + 'px'
      fly.style.top = (targetRect.top + targetRect.height / 2 - 30) + 'px'
      fly.style.width = '60px'
      fly.style.height = '60px'
      fly.style.opacity = '0'
    })
  })

  setTimeout(() => fly.remove(), 700)
}
  renderComparePage = async () => {
    const container = document.querySelector(this.selectors.container)
    if (container) {
      let noItemAvailable = true

      if (this.products.length) {
        const promises = this.products.map(async hdl => {
          const prodHTML = await fetchCache(`/products/${hdl}?view=compare`)
          const item = document.createElement("DIV");
          item.classList.add("m:hidden", "m:column", "m-compare-card");
          item.innerHTML = prodHTML
          if (item.querySelector(this.selectors.item)) {
            noItemAvailable = false
            this.productNodes[hdl] = item
          }
        })

        await Promise.all(promises)

        // Render in order
        this.products.forEach(hdl => {
          const prodNode = this.productNodes[hdl]
          if (prodNode) {
            container.appendChild(prodNode)
            prodNode.classList.remove('m:hidden')
          }
        })
      }

      if (noItemAvailable) {
        this.showNoProductsMessage()
      }

      container.classList.add('is-visible')
    }
  }

  showNoProductsMessage = () => {
    const container = document.querySelector(this.selectors.container)
    const noProducts = document.querySelector(this.selectors.noProducts)

    container.classList.add('m:hidden')
    noProducts.classList.remove('m:hidden')
  }
}

MinimogTheme.CompareProduct = new CompareProduct()

